<script>
export default {
  name: "AppButton",
  props: {
    tag: {
      type: String,
      default: "button",
    },
    colour: {
      default: "primary",
      validator(value) {
        return (
          [
            "primary",
            "secondary",
            "white",
            "grey",
            "text",
            "confirm",
            "delete",
            "delete-fill",
            "close",
          ].indexOf(value) !== -1
        );
      },
    },
  },
  mounted() {
    this.$el.classList.add("button", `button--${this.colour}`);
  },
  render(createElement) {
    return createElement(
      this.tag,
      {
        on: this.$listeners,
        attrs: this.$attrs,
      },
      this.$slots.default
    );
  },
};
</script>

<style>
.button {
  @apply inline-flex outline-none text-white w-full h-12 font-semibold items-center justify-center no-underline cursor-pointer font-semibold shadow;
  transition: all 0.2s ease-in-out;
}

.button:focus {
  @apply outline-none shadow-lg;
}

.button:hover {
  @apply shadow-lg;
}

.button--small {
  @apply h-8;
}

.button--text,
.button--close,
.button--confirm,
.button--confirm {
  @apply text-primary-700 border border-transparent;
  transition: all 0.2s ease-in-out;
}

/* .button--close,
.button--confirm,
.button--delete {
  @apply w-48;
} */

.button--text:hover {
  @apply border-primary-700;
}

.button--close {
  @apply text-negative-700;
}

.button--close:hover {
  @apply border-negative-700;
}

.button--confirm {
  @apply text-positive-700 border-positive-700;
}

.button--confirm:hover {
  @apply bg-positive-700 text-white;
}

.button--delete {
  @apply text-negative-700 border-negative-700;
}

.button--delete:hover {
  @apply bg-negative-700 text-white;
}

.button--delete-fill {
  @apply bg-negative-700 border-negative-700 text-negative-50;
}

.button--delete-fill:hover {
  @apply bg-negative-900 border-negative-900 text-negative-100;
}

.button--primary {
  @apply bg-secondary-500 text-black;
}

.button--primary:hover {
  @apply text-white bg-secondary-700;
}

.button--secondary {
  @apply bg-primary-500 text-white;
}

.button--secondary:hover {
  @apply text-white bg-primary-700;
}

.button--white {
  @apply bg-white text-black;
}

.button--white:hover {
  @apply text-black bg-primary-500;
}

.button--grey {
  @apply bg-grey-500;
}

.button--grey:hover {
  @apply text-white bg-grey-700;
}
.button[disabled] {
  @apply cursor-not-allowed bg-grey-100 text-grey-700 border-2 border-grey-500;
}
.button[disabled]:hover {
  @apply shadow;
}
.button--confirm[disabled],
.button--confirm[disabled]:hover,
.button--close[disabled],
.button--close[disabled]:hover {
  @apply text-grey-400 border-grey-400 bg-transparent;
}
.button:focus {
  @apply shadow-outline;
}
</style>
